module.exports = {"330203001":"南门街道","330203002":"江厦街道","330203003":"西门街道","330203004":"月湖街道","330203005":"鼓楼街道","330203006":"白云街道","330203007":"段塘街道","330203008":"望春街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330203.json
// module id = 878
// module chunks = 0